module.exports = __webpack_public_path__ + "img/training-4.4c988ec0.jpg";